import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Story from '../components/Story';
import Features from '../components/Features';
import Timeline from '../components/Timeline';
import Collectible from '../components/Collectible';
import CustomizeCTA from '../components/CustomizeCTA';
import { content } from '../data/mock';

export default function Home() {
  const [lang, setLang] = useState('ar');
  const t = content[lang];

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.title = lang === 'ar'
      ? 'يوم التأسيس السعودي | قصة بدايتنا 1727-2027'
      : 'Saudi Founding Day | Our Founding Story 1727-2027';
  }, [lang]);

  return (
    <div dir={lang === 'ar' ? 'rtl' : 'ltr'} lang={lang}>
      <Navbar lang={lang} setLang={setLang} />
      <main>
        <Hero t={t} />
        <Story t={t} />
        <Features t={t} />
        <Timeline t={t} />
        <Collectible t={t} lang={lang} />
        <CustomizeCTA t={t} lang={lang} />
      </main>
    </div>
  );
}
